<form (keydown.enter)="$event.preventDefault()" [formGroup]="inputForm"
      class="flex flex-col full-grow-no-shrink-no-basis">
  <div class="flex flex-row justify-start items-start auto-flex">
    <mat-form-field appearance="outline" class="flex-1-0-100">
      <mat-label>Column Name</mat-label>
      <input matInput formControlName="value" required
             particleAnalytics
             analyticsCategory="list-name" data-cy="Column Name"
             analyticsAction="list-name">
      <mat-error *ngIf="inputFormError.value.required">
        Please type a column name.
      </mat-error>
      <mat-error *ngIf="inputFormError.value.sameColumn">
        List name cannot be same
      </mat-error>
    </mat-form-field>

  </div>
</form>
